import { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import useLocalStorage from '../../hooks/useLocalStorage';

import styles from './Player.module.css';

import mascot1 from '../../assets/video/mascot1.webm';
import mascot2 from '../../assets/video/mascot2.webm';
import mascot3 from '../../assets/video/mascot3.webm';
import supportTheTeam from '../../assets/video/supportTheTeam.webm';

const names = {
  S7: 'mascot1',
  S8: 'mascot2',
  S9: 'mascot3',
  S10: 'supportTheTeam',
};

const urls = {
  mascot1,
  mascot2,
  mascot3,
  supportTheTeam,
};

const defaultName = 'mascot1';

export const Player = ({ currentState }) => {
  const [playerNumber, setPlayerNumber] = useLocalStorage(
    'player',
    defaultName,
  );

  useEffect(() => {
    if (!Object.values(names).includes(playerNumber)) {
      setPlayerNumber(defaultName);
    }
  }, []);

  useEffect(() => {
    const playerStates = ['S7', 'S8', 'S9', 'S10'];
    if (!currentState || !playerStates.includes(currentState)) {
      return;
    }

    setPlayerNumber(names[currentState]);
  }, [currentState]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={playerNumber}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.videoBlock}
      >
        <video autoPlay="autoplay" muted="muted" loop>
          <source src={urls[playerNumber]} type="video/webm" />
        </video>
      </motion.div>
    </AnimatePresence>
  );
};
